export default __webpack_public_path__ + "static/media/coursesdis.cc3c8ac2.png";